import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import {
  Form,
  CompaniesAutocomplete,
  UsersAutocomplete,
  DiscountsAutocomplete,
  AgreementsAutocomplete,
} from "@shared/components";

import { useModeOptions, useDiscountTypeOptions } from "@shared/options";

export const UsageListFilters = React.memo(() => {
  const translate = useTranslate();

  const { getModeOptions } = useModeOptions();
  const { getDiscountTypeOptions } = useDiscountTypeOptions();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <CompaniesAutocomplete
          name="company"
          label={translate("v1/usage_admin.filters.company")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="state"
          label={translate("v1/usage_admin.filters.state")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="city"
          label={translate("v1/usage_admin.filters.city")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <UsersAutocomplete
          name="user"
          label={translate("v1/usage_admin.filters.user")}
          labelField="email"
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <AgreementsAutocomplete
          name="agreement"
          label={'Convênio'}
        />
      </Grid>
      {/*
      <Grid size={{ xs: 12 }}>
        <DiscountsAutocomplete
          name="discount"
          labelField="name"
          valueField="id"
          label={translate("v1/usage_admin.filters.discount")}
        />
      </Grid> */}

      <Grid size={{ xs: 6 }}>
        <Form.Select
          name="discount__mode"
          label={translate("v1/usage_admin.filters.discount_mode")}
          options={getModeOptions()}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Select
          name="discount__type"
          label={translate("v1/usage_admin.filters.discount_type")}
          options={getDiscountTypeOptions()}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="payment_status"
          label={translate("v1/usage_admin.filters.payment_status")}
          options={[
            { value: "", label: translate("options.none") },
            { value: "created", label: translate("v1/usage_admin.filters.payment_created") },
            { value: "paid", label: translate("v1/usage_admin.filters.payment_paid") },
            { value: "canceled", label: translate("v1/usage_admin.filters.payment_canceled") },
            { value: "seen", label: translate("v1/usage_admin.filters.payment_seen") },
          ]}
        />
      </Grid>
    </Grid>
  );
});
